import { UI_ROOT } from "../../../app";
//const UI_ROOT = "own";
import  ClienteListOwn from "./view/cliente.list.own";
import  ClienteListMui from "./view/cliente.list.mui";

export const ClienteList = () => {
    switch (UI_ROOT) {
        case "own":
            return <ClienteListOwn/>
    
        default:
            return  <ClienteListMui />
    }
}



